<template>
  <img
    v-if="image"
    :src="`data:image/png;base64,${image}`"
    style="object-fit: cover;object-position: 0 0"
    class="bg-black"
    @click="onClick"
  >
</template>

<script>
import apiService from '../api/apiService'

export default {
    name: 'ImageComponent',
    props: {
        imageId: {
            type: String,
            required: true
        }

    },
    data () {
        return {
            image: null
        }
    },
    computed: {

        id: function () {
            return this.imageId
        }
    },

    watch: {
        imageId: function (newVal, oldVal) { // watch it
            if (newVal && newVal.length > 0 && newVal !== oldVal) {
                this.loadImg(newVal)
            }
        }
    },

    async mounted () {
        if (this.imageId && this.imageId.length > 0) {
            this.loadImg(this.imageId)
        }
    },
    methods: {
        onClick (arg) {
            this.$emit('click', arg)
        },
        async loadImg (id) {
            var response = await apiService.getImage(id)
            this.image = response
        }
    }
}

</script>

<style scoped>

</style>
